import React from "react";
import {
  Container,
  ContainerText,
  ContainerInfo,
  ContainerIcon,
  ContainerTextIcon,
  IconContainer,
} from "./style";
import Trivia from "../../img/Trivia";
import ScoreIcon from "../../img/ScoreIcon";
import AwarsIcon from "../../img/AwarsIcon";
import NotiIcon from "../../img/NotiIcon";
import GroupIcon from "../../img/GroupIcon";
import MicroIcon from "../../img/MicroIcon";
import { useScroll } from "../../context/UseContextScroll.js";
import { useTranslation } from "react-i18next";

const Orientation = () => {
  const { scroll } = useScroll();
  const [t] = useTranslation("global");

  const DataOrientation = [
    {
      id: 1,
      Icon: Trivia,
      title: t("titleTrivias.titleTrivias"),
      text: t("trivias.trivias"),
    },
    {
      id: 2,
      Icon: ScoreIcon,
      title: t("titlePunctuation.titlePunctuation"),
      text: t("trivias.trivias"),
    },
    {
      id: 3,
      Icon: AwarsIcon,
      title: t("titleAwars.titleAwars"),
      text: t("textAwars.textAwars"),
    },
    {
      id: 4,
      Icon: NotiIcon,
      title: t("titleNotifications.titleNotifications"),
      text: t("titleNotificacion.titleNotificacion"),
    },
    {
      id: 5,
      Icon: GroupIcon,
      title: t("titleGROUPS.titleGROUPS"),
      text: t("textGROUPS.textGROUPS"),
    },
    {
      id: 6,
      Icon: MicroIcon,
      title: t("titleMICROTOURNAMENTS.titleMICROTOURNAMENTS"),
      text: t("textMICROTOURNAMENTS.textMICROTOURNAMENTS"),
    },
  ];

  return (
    <Container id="business">
      <ContainerText>
        <h1>{t("titleOrientation.titleOrientation")}</h1>
        <p>{t("textTitleOrientation.textTitleOrientation")}</p>
      </ContainerText>
      <ContainerInfo>
        {DataOrientation.map((item, index) => (
          <ContainerIcon scroll={scroll} key={index} text={item.id}>
            <IconContainer>
              <item.Icon />
            </IconContainer>
            <ContainerTextIcon text={item.id}>
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </ContainerTextIcon>
          </ContainerIcon>
        ))}
      </ContainerInfo>
    </Container>
  );
};

export default Orientation;
